<style scoped>
.hotel-name{
	padding-bottom: 10px;
	border-bottom: 1px solid #ddd;
}
.hotel-name .small-title {
    font-size: 15px;
    padding: 20px 0 0 10px;
		height: 45px;
    position: relative;
}

.hotel-name .small-title:before {
    content: "";
    position: absolute;
    left: 0;
    top: 25px;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
    border-left: 6px solid #fe6d18;
    border-bottom: 5px solid transparent;
    z-index: 1;
}

.info-list > p > .bold{
	font-weight: bold;
	
}
</style>

<template>
	<div>
	    <section class="order-main">
	        <div class="content">
	        	<div v-if="hotel">
		            <div class="hotel-name">
		                Hotel Booking Confirmation（CN）
										<div class="hotel-name-btn">
											<span class="back-btn" onclick="window.history.go(-1)">return</span>
											<span  v-if="hotel['I'].MainOrderStatus==27" style="background: #1478e4;color: #fff;" class="check-btn" @click="checkStatus()">Checked in</span>
											<span v-if="hotel['I'].MainOrderStatus==28" style="background: #1478e4;color: #fff;" class="check-btn no-click">Checked in</span>
											<span href="javascript:void(0)" class="print-btn" @click="routetoPage('orderPrint')">Print</span>
										</div>
										<div class="small-title">{{hotel.I.EnHotelName}}</div>
		            </div>
		            <!--startprint-->
		            <div class="order-info">
		                <!-- info-title -->
		                <div class="info-title">Basic information</div>
		                <div class="info-list">
		                    <p><label class="replace-label">Booking No.：</label>
		                    	{{hotel['I'].PurchaseOrderId}}
		                    	<label >({{hotel.I.OrderType=='新单'?'New':hotel.I.OrderType=='变更单'?'Amend':hotel.I.OrderType=='取消单'?'Cancel':hotel.I.OrderType=='无效单'?'Invalid':''}})</label>
												<span class="copyOrderNumber" :data-clipboard-text="hotel['I'].PurchaseOrderId" @click="copyOrderNumber"></span>
		                    </p> 
												<p><label class="replace-label">Conf. No.：</label>{{ConfirmNo}}</p>
		                    
		                    <p><label class="replace-label">Guest Name：</label>{{hotel['I'].GuestName}} <span class="copyOrderNumber" :data-clipboard-text="hotel['I'].GuestName" @click="copyOrderNumber"></span></p>
												<p><label class="replace-label">Stay Period：</label>{{hotel['I'].CheckIn|delUTC|dateToDvd}} - {{hotel['I'].CheckOut|delUTC|dateToDvd}} <span class="bold">	（{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}} night）</span></p>
												<p><label class="replace-label">Total Room Night(s)：</label><span class="bold">{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)*hotel['I'].RoomNum}}</span></p>
												<p><label class="replace-label">Room Type：</label><span class="font-18 color-red"> {{hotel['I'].EnRoomName}} <span class="bold">（{{hotel['I'].RoomNum}} room）</span></span></p>
												<p v-if="getDays(hotel['I'].CancelTime,hotel['I'].CreatTime)>0"><label class="replace-label">Cancellation Policy：</label>{{hotel['I'].CancelTime|dateLong}}</p>
												<p v-else><label class="replace-label">Cancellation Deadline：</label></p>
		                    <p><label class="replace-label">Requirements：</label><span class="color-red">{{hotel['I'].Notes||'无'}}</span></p>
		                    
		                </div>

		                <!-- info-title -->
		                <div class="info-title">Rate Information</div>
		                <table cellspacing="0">
		                    <thead>
		                        <tr>
		                            <!-- <td>状态</td> -->
		                            <!-- <td>房型名称</td> -->
		                            <td>Check in</td>
		                            <td>Room Number(s)</td>
		                            <!-- <td>晚数</td> -->
		                            <td>Breakfast</td>
		                            <td>Currency</td>
		                            <td>Rate</td>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        <tr v-for="price in hotel.P">
		                            <!-- <td>新单</td> -->
		                            <!-- <td>{{price.RoomName}}</td> -->
		                            <td>{{price.CheckIn|delUTC|dateToLineDvd}}</td>
		                            <td>{{price.RoomNum}}</td>
		                            <!-- <td>{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}}</td> -->
		                            <td>{{price.EnBreakfastName}}</td>
		                            <td>{{price.BaseCurrency}}</td>
		                            <td>{{price.BasePrice}}</td>
		                            

		                      
		                        </tr>
		                    </tbody>
		                </table>

		                <!-- title -->
		                <div class="info-title">Surcharge information</div>
		                <table cellspacing="0">
		                    <thead>
		                        <tr>
		                            <!-- <td>房型名称</td> -->
		                            <td>Date</td>
		                            <td>Type</td>
		                            <td>Name</td>
		                            <td>Currency</td>
		                            <td>Price</td>
		                            <td>Count</td>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        <tr v-for="overcase in hotel.S" v-if="hotel.S&&hotel.S.length>0">
		                           
		                            <!-- <td>{{overcase.RoomName}}</td> -->
		                            <td>{{overcase.SurchargeDate|delUTC|dateToLineDvd}}</td>
		                            <td>{{overcase.SurchargeTypeName}}</td>
		                            <td>{{overcase.SurchargeName}}</td>
		                            <td>{{overcase.BaseCurrency}}</td>
		                            <td>{{overcase.BasePrice}}</td>
		                            <td>{{overcase.SurchargeNum}}</td>
		                        </tr>
		                        <tr  v-if="!hotel.S||hotel.S.length<=0">
		                            <td colspan="9">none</td>
		                        </tr>
		                    </tbody>
		                </table>

		                <!-- title -->
		                <div class="info-title">Total</div>
		                <div class="total">
		                    <p><span class="font-18 color-red">{{hotel['I'].Currency}} {{hotel.TotalPrice}}</span></p>
		                    <p>payment mode：Prepay</p>
		                </div>
		                <!--endprint-->
		                <div class="order-remark " >
		                    <div class="e-form">
		                        <div class="form-contorl">
		                            <label class="title">Conf. No.：</label>
		                            <input type="text" v-model="hotel['I'].ConfirmNo">
		                            <span class="color-red ">Special symbols can be entered：","、"-"、";"、"#"</span>
		                        </div>
		                        <div class="form-contorl">
		                            <label class="title">Remark：</label>
		                            <textarea name="" id="" rows="4" v-model="hotel['I'].ConfirmRemark"></textarea>
		                        </div>
		                        <div v-show="hotel['I'].HandleStatesId==0">

			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 0">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >accept reserve</div>
			                            <div class="form-btn" @click="save('Reject')">refuse reserve</div>
			                        </div>
			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 1">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >accept alter</div>
			                            <div class="form-btn" @click="save('Reject')">refuse alter</div>
			                        </div>
			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 2">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >accept cancel</div>
			                            <div class="form-btn" @click="save('Reject')">refuse cancel</div>
			                        </div>
		                        </div>


		                        <div class="form-contorl " v-show="hotel['I'].HandleStatesId!=0">
		                            <label class="title"></label>
		                            <div class="form-btn active" @click="confrim">alter</div>
		                           
		                        </div>
		                    </div>
												<p style="text-align: right;color: #878787;margin:0;font-size:14px;"><label class="replace-label">Booking maker：</label>{{hotel['I'].RealName}}（phone：{{hotel['I'].Phone||'none'}}   fax：{{hotel['I'].Fax||'none'}}）</p>
		                </div>
		            </div>
				</div>
	        </div> 
	    </section>
	    <section class="section-footer">
	        <div class="content">
	            <p>国内产品：0755-82365588-1  香港产品：0755-82365588-2  海外产品：0755-82365588-3  澳门产品：0756-8281308</p>
	            <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
	        </div>
	    </section>
			<div class="mask" v-show="showRp">                        
				<div class="error-box">                        
					<h1>Tips</h1>
					<h2>{{RpTxt}}</h2> 
					<h2 style="text-align: center;max-height: 200px;overflow-y: auto;" v-show="alertList.length">
						<div style="line-height: 1.5em;" v-for="item in alertList" :key="item.txt">{{ item.txt }}</div>
					</h2>                     
					<div @click="showRp=false">OK</div>                        
				</div>                        
			</div>		
	</div>
</template>
<script>
import Clipboard from "clipboard";
export default {
	name:"orderEdit",
	data(){
		return{
	    	ebID:this.dao.get('ebID'),
	    	VerCol:this.dao.get('VerCol'),
	    	hotel:'',
				ConfirmNo:'',
				RpList:[],
				showRp:false,
				RpTxt:''

		}
	},
	computed: {
			alertList() {
				return this.RpList
					.filter(r => {
						if (r.A) return false;
						const stock = r.SC != null ? r.SC : r.SSC   // 等价 SSC ?? SC
						return stock <= 1
					})
					.map(r => ({
						txt: r.PD.replace(/\//g,'-') +
								((r.SC != null ? r.SC : r.SSC) == 1
									? ' Only 1 room left — please replenish stock promptly.'
									: ' Sold out — please restock promptly.')
					}))
			}
	},
	methods:{
			// 计算日期差
			getDays(s1, s2) {
					const time1 = Date.parse(s1);
					const time2 = Date.parse(s2);
					var time = time1 - time2;
					return time;
			},
			copyOrderNumber() {
				var clipboard = new Clipboard(".copyOrderNumber");
				var that = this;
				clipboard.on("success", e => {
					// console.log('复制成功')
					that.error({ title: "Tips", content: "Successful replication" });
					// 释放内存
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					// 不支持复制
					that.error({ title: "Tips", content: "This browser does not support automatic replication" });
					// console.log('该浏览器不支持自动复制')
					// 释放内存
					clipboard.destroy();
				});
			},
			checkStatus(){
				var that=this;
	      var params={
	          mainOrderId: that.hotel['I'].MainOrderId
	      }
	      that.isLoading=true;
	      that.getRequest({
	          url: that.Api.checkStatus,
	          params: params
	      }).then(res => {
	          that.isLoading=false;
	          if (res.IsSuccess) {
							that.initData()	
							that.error({ title: 'Tips', content: 'Success' });
	          } else {
	            that.initData()
	            that.error({ title: 'Tips', content: 'Failed' });
	          }
	      });
			},
  		initData () {
	        var that=this;
	        var params={
	            ebID: that.ebID,
	            ver: that.VerCol
	        }
	        that.isLoading=true;
	        that.getRequest({
	            url: that.Api.getOrderList,
	            params: params
	        }).then(res => {
	           that.isLoading=false;
	            if (res) {
	                that.hotel=res;
									that.ConfirmNo = res["I"].ConfirmNo||"none"
	            } else {
	                that.hotel='';
	                that.error({ title: 'Tips', content: 'No data is queried' });
	            }
	        });
	    },
			getRp(){
        var that=this;
				that.showRp = false 
        var params={
          hotel: that.hotel['I'].HotelId,
          room: that.hotel['I'].RoomId,
          rp: that.hotel['P'][0].RatePlanId,
          rate: that.hotel['P'][0].RateId,
          date: that.hotel['I'].CheckIn.slice(0, 10).replace(/-/g, ''),
          endDate:that.hotel['I'].CheckOut.slice(0, 10).replace(/-/g, '')
        }
        that.getRequest({
          url: that.Api.getRp,
          params: params
        }).then(res => {
					that.showRp = true
        	if (res && res.length>0) {
            that.RpList = res  
          }
        });
      },
  		save (type) {
	        var that=this;
	        var params={
	            EBID: that.ebID,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark,
	            Ver: that.VerCol,
	        }
	       
	        that.isSaving=true;
	        that.patchRequest({
	            url: that.Api.getOrderList+'/'+type,
	            params: params
	        }).then(res => {
	        	that.isSaving=false;
	            if (res) {
								if(that.hotel['I'].OrderTypeId == 0){
									that.RpTxt = res.Msg
									that.getRp()
									that.initData();
								}else{
									that.error({ title: 'Tips', content: res.Msg });
	            		that.initData();
								}
	            	
						// window.history.go(-1);
	            } else {
	                that.error({ title: 'Tips', content: 'No, please try again' });
	            }
	        });
	    },
	    PrintOrder() {   
		   // var bdhtml=window.document.body.innerHTML;   
		   // var sprnstr="<!--startprint-->";   
		   // var eprnstr="<!--endprint-->";   
		   // var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);   
		   //  prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr)); 
		   //  console.log(prnhtml);  
		   //  window.document.body.innerHTML=prnhtml;  
		    window.print();   
		},
		confrim () {
	        var that=this;
	        if(!that.hotel['I'].ConfirmNo&&!that.hotel['I'].ConfirmRemark){
	        	that.error({ title: 'Tips', content: 'Please enter the hotel ConfirmNO or Remarks' });
	        	return;
	        }
	        var params={
	            EBID: that.ebID,
	            Ver:that.VerCol,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark
	        }
	        that.isSaving=true;
	       
	        that.patchRequest({
	            url: that.Api.updateConfrim,
	            params: params
	        }).then(res => {
	        
	        	that.isSaving=false;
	            if (res) {
	            	that.error({ title: 'Tips', content: res.Msg });
					window.history.go(-1);
	            } else {
	                that.error({ title: 'Tips', content: 'No, please try again' });
	            }
	        });
	    }
		
	},
	mounted(){
		this.initData();
	}
}

	
</script>


// WEBPACK FOOTER //
// src/components/order/OrderEdit.vue